import { DataSoldProductsByLocation, FetchSoldProductsSearchProps, ListSoldProductsByLocation } from 'lib/models/listSoldProducts';
import { useCallback, useEffect, useState } from 'react';

function useListSoldProductsByLocation(searchProps?: FetchSoldProductsSearchProps) {
	const [loading, setLoading] = useState<boolean>(true);
	const [SoldProductsByLocation, setSoldProductsByLocation] = useState<DataSoldProductsByLocation>(
		{} as DataSoldProductsByLocation
	);

	const refetch = useCallback(async (props?: FetchSoldProductsSearchProps) => {
		setLoading(true);
		const response = await ListSoldProductsByLocation(props || searchProps);
		setSoldProductsByLocation(response);
		setLoading(false);
	}, [searchProps]);

	useEffect(() => {
		refetch(searchProps);
	}, [refetch, searchProps]);

	return { loading, SoldProductsByLocation, refetch, setLoading };
}

export default useListSoldProductsByLocation;
